import { createRouter, createWebHistory } from "vue-router";

import TheMainLayout from "@/layouts/TheMainLayout";
import TheLegalLayout from "@/layouts/TheLegalLayout";
import TheImpressumView from "@/views/TheImpressumView";
import TheDatenschutzView from "@/views/TheDatenschutzView";

const routes = [

  {
    path: "/",
    name: "home",
    component: TheMainLayout,
    meta: { title: "WIESNERD – IT, Automation und Webentwicklung" },
  },

  {
    path: "/impressum",
    name: "impressum",
    component: TheLegalLayout,
    children: [
      {
        path: "",
        component: TheImpressumView,
      },
    ],
    meta: { title: "Impressum – WIESNERD" },
  },

  {
    path: "/datenschutz",
    name: "datenschutz",
    component: TheLegalLayout,
    children: [
      {
        path: "",
        component: TheDatenschutzView,
      },
    ],
    meta: { title: "Datenschutz – WIESNERD" },
  },

];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.beforeEach((to, from, next) => {

  document.title = to.meta.title || "WIESNERD";
  next();

});

export default router;
